"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = accessors;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function accessors(target) {
  target.accessors = (0, _extends3.default)({}, target.accessors, {
    xTicks: function xTicks(base, axis) {
      return axis.xAxis.tickValues();
    },
    yTicks: function yTicks(base, axis) {
      return axis.yAxis.tickValues();
    },
    xRange: function xRange(base, axis) {
      return axis.yAxis.scale().range();
    },
    yRange: function yRange(base, axis) {
      return axis.xAxis.scale().range();
    },
    xScale: function xScale(base, axis) {
      return axis.xAxis.scale();
    },
    yScale: function yScale(base, axis) {
      return axis.yAxis.scale();
    }
  });
}